import React from 'react';

const PlusFilledSVG = ({ color = 'black', className,onClick, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      className={className}
      onClick={onClick}
    >
      <circle cx="11" cy="11" r="11" fill={color} />
      <path
        d="M11.0103 16.7311C11.2169 16.7311 11.3822 16.6486 11.5267 16.5041C11.6713 16.3595 11.7539 16.1942 11.7537 15.9878L11.7332 11.7537L15.9878 11.7537C16.1944 11.7537 16.3596 11.6711 16.5041 11.5267C16.6487 11.382 16.7313 11.2168 16.7311 11.0103C16.7311 10.5971 16.4008 10.2668 16.0082 10.2874L11.7332 10.3078L11.7332 6.05328C11.7332 5.6401 11.4029 5.30975 11.0103 5.33035C10.5971 5.33035 10.2668 5.6607 10.2874 6.05328L10.2874 10.3078L6.03282 10.3078C5.61964 10.3078 5.28928 10.6382 5.30989 11.0308C5.30989 11.4439 5.64024 11.7743 6.03282 11.7537L10.2874 11.7537L10.2874 16.0082C10.2668 16.4005 10.5972 16.731 11.0103 16.7312L11.0103 16.7311Z"
        fill="white"
      />
    </svg>
  );
};

export default PlusFilledSVG;
